import { CapacitorCookies } from "@capacitor/core";
import _ from "lodash";
import React from "react";
import CookieConsent from "react-cookie-consent";
import PrivacyPolicyText from "./PrivacyPolicyText";
import { isWebViewFromAndroid } from "../../utils/utils";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const CookieNotice = () => {
  const [showCookieNotice, setShowCookieNotice] = React.useState(false);
  const { t } = useTranslation();
  React.useEffect(() => {
    const checkCookieConsent = async () => {
      const regularCookieConsent = _.trim(
        document.cookie?.split(";").find((cookie) => cookie.includes("cookiesConsent"))
      );

      setShowCookieNotice(regularCookieConsent !== "cookiesConsent=true");
    };
    checkCookieConsent();
  }, []);

  return isWebViewFromAndroid() ? (
    showCookieNotice && (
      <CookieConsent
        location="none"
        buttonText="Accept"
        enableDeclineButton
        overlay
        disableStyles
        overlayClasses="CookieConsent__overlay"
        containerClasses="CookieConsent__container"
        contentClasses="CookieConsent__content"
        buttonWrapperClasses="CookieConsent__buttonWrapper"
        onAccept={() => {
          CapacitorCookies.setCookie({ key: "cookiesConsent", value: "true" });
        }}
        setDeclineCookie={false}
        onDecline={() => {
          window.location.replace("https://google.com");
        }}
        cookieName="cookiesConsent"
        expires={150}
      >
        <div>
          <PrivacyPolicyText />
        </div>
      </CookieConsent>
    )
  ) : (
    <CookieConsent
      buttonText={t("cookie_notice.accept")}
      disableStyles
      onAccept={() => {
        CapacitorCookies.setCookie({ key: "cookiesConsent", value: "true" });
      }}
      onDecline={() => {
        window.location.replace("https://google.com");
      }}
      cookieName="cookiesConsent"
      expires={150}
      overlayClasses="CookieConsentSmall__overlay"
      containerClasses="CookieConsentSmall__container"
      contentClasses="CookieConsentSmall__content"
      buttonWrapperClasses="CookieConsentSmall__buttonWrapper"
    >
      <div>
        <Trans i18nkey="cookie_notice.short_text">
          This website uses cookies to improve your experience. By continuing to browse, you consent
          to our use of cookies. For more information on how we use cookies and how to manage them,
          please see our{" "}
          <Link className="text-green-900!" to="/privacy-policy">
            Cookie Policy
          </Link>
          .
        </Trans>
      </div>
    </CookieConsent>
  );
};

export default CookieNotice;
